import { getJson, patchJson, postJson } from "../../core/http";

export function updateAccountProfile(payload) {
  return patchJson("/account", payload);
}

export function fetchAccount() {
  return getJson("/account");
}

export function fetchSubscriptionOverview() {
  return getJson("/api/v1/subscription");
}

export function cancelSubscriptionRenewal() {
  return postJson("/api/v1/subscription/cancel", {});
}

export function resumeSubscriptionRenewal() {
  return postJson("/api/v1/subscription/resume", {});
}
